export const WEB_VIEW_MODE_SUB_URL = "web-view";
export const X_MOBILE_HEADER = "x-mobile-request";
